 function getOrCreateUserId() {
  let userid = localStorage.getItem("fb_userid");
  if (!userid) {
    userid = crypto.randomUUID(); // Modern browsers support this
    localStorage.setItem("fb_userid", userid);}
     return userid;}

function generateEventId() {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;}
  const eventId=generateEventId();

function fireFbEvent({ eventName, items, totalValue }) {
  const eventId = generateEventId(); 
  const eventSourceUrl = window.location.href;
  const phoneNumber = document.getElementById("otp-phone")?.value?.trim() || "";
  const customerEmail = `${phoneNumber}@nomail.com`;
  const userid = getOrCreateUserId();

  // 1️⃣ Facebook Pixel Client-Side Event
  fbq('track', eventName, {
    value: totalValue,
    currency: 'INR',
    contents: items.map(it => ({
      id: it.variant_id.toString(),
      quantity: it.quantity
    })),
    content_type: 'product'
  }, {
    eventID: eventId
  });

  // 2️⃣ Facebook Server-Side Event
  sendFacebookServerEvent({
    userid,
    eventName,
    eventSourceUrl,
    phone: phoneNumber,
    email: customerEmail,
    items,
    totalValue,
    eventId
  });
}
function sendFacebookServerEvent({ userid,eventName, eventSourceUrl, phone, email, items, totalValue, eventId }) {
  const payload = {
    data: [{
      uuid:userid,
      event_name: eventName,
      event_time: Math.floor(Date.now() / 1000),
      event_id: eventId,
      event_source_url: eventSourceUrl,
      user_data: {
        ph: [phone],
        em: [email]
      },
      custom_data: {
        currency: "INR",
        value: totalValue,
        contents: items.map(item => ({
          id: item.variant_id.toString(),
          quantity: item.quantity,
          delivery_category: "home_delivery"
        }))
      }
    }]
  };
  //  console.log("this is the palyload"+JSON.stringify(payload)); 
  // console.log("Calling the api ================")
  fetch("https://utils.ko-tech.in/events/meta-events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    // .then(data => console.log(" FB Server Event Sent", data))
    .then(() => {})
    .catch(err => console.error(" Error sending FB server event:", err));
}